import React from 'react';
import Header from '../Components/Header';
import { Link } from 'react-router-dom';
import HowItWorksImg from './../Images/how-it-works.png';
import Browse from './../Images/browse.png';
import Invest from './../Images/invest.png';
import InvestIcon from './../Images/invest.svg';
import Legal from './../Images/legal.png';
import Monitor from './../Images/monitor.png';
import Sell from './../Images/sell.png';
import { FaChevronRight, FaSearch } from "react-icons/fa";
import { BsGraphUp, BsFileEarmarkTextFill } from "react-icons/bs";
import Footer from '../Components/Footer';

const HowItWorks = () => {
  return (
    <>
      <Header />
      <div className="banner w-100 mb-90" style={{ backgroundImage: `url(${HowItWorksImg})` }}>
        <div className="container">
          <div className="banner-title text-center">
            <h1>How It Works</h1>
            <p><Link to="/">Home</Link> <span><FaChevronRight /></span> How It Works</p>
          </div>
        </div>
      </div>

      <div className="mb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 my-auto d-flex justify-content-start order-lg-1 order-2">
            <div class="side-bx">
              <div className="side-icon mb-3">
                <span><FaSearch/></span>
              </div>
              <div className="side-text">
                <h2>Browse Offerings</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationp.</p>
              </div>
             </div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <div className="side-img mb-4 mb-lg-0">
                <img src={Browse} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-90">
        <div className="container">
          <div className="row">
          <div className="col-lg-6">
              <div className="side-img mb-4 mb-lg-0">
                <img src={Invest} alt="" />
              </div>
            </div>
            <div className="col-lg-6 my-auto d-flex justify-content-end">
            <div class="side-bx">
              <div className="side-icon mb-3">
                <span><img src={InvestIcon} width="20px" alt="" /></span>
              </div>
              <div className="side-text">
                <h2>Browse Offerings</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationp.</p>
              </div>
            </div>
         </div>
          </div>
        </div>
      </div>
      <div className="mb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 my-auto d-flex justify-content-start  order-lg-1 order-2">
            <div class="side-bx">
              <div className="side-icon mb-3">
                <span><BsFileEarmarkTextFill/></span>
              </div>
              <div className="side-text">
                <h2>Receive Legal Documents</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationp.</p>
              </div>
             </div>
            </div>
            <div className="col-lg-6  order-lg-2 order-1">
              <div className="side-img mb-4 mb-lg-0">
                <img src={Legal} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-90">
        <div className="container">
          <div className="row">
          <div className="col-lg-6 ">
              <div className="side-img mb-4 mb-lg-0">
                <img src={Monitor} alt="" />
              </div>
            </div>
            <div className="col-lg-6 my-auto d-lg-flex justify-content-end">
            <div class="side-bx">
              <div className="side-icon mb-3">
                <span><BsGraphUp/></span>
              </div>
              <div className="side-text">
                <h2>Monitor Portfolio</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationp.</p>
              </div>
            </div>
         </div>
          </div>
        </div>
      </div>
      <div className="mb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 my-auto d-flex justify-content-start  order-lg-1 order-2">
            <div class="side-bx">
              <div className="side-icon mb-3">
                <span><FaSearch/></span>
              </div>
              <div className="side-text">
                <h2>Sell</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitationp.</p>
              </div>
             </div>
            </div>
            <div className="col-lg-6  order-lg-2 order-1">
              <div className="side-img mb-4 mb-lg-0">
                <img src={Sell} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  )
}

export default HowItWorks